import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { environment } from '../../../environments/environment';
import { UserService } from 'src/app/_services/user.service';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-manage-console-execution',
  templateUrl: './manage-console-execution.component.html',
  styleUrls: ['./manage-console-execution.component.scss']
})
export class ManageConsoleExecutionComponent implements OnInit {

  headerOptions = {
    showSetting: false,
    showSearch: false,
    heading: "Manage Console Execution Data",
    data: undefined,
  };
  showForm: boolean = false;
  projectId: string;
  projectData: Object;
  searchString: string = '';
  consoleData: any = [];
  consoleTableData: any = [];
  inputFieldsList: any = [];
  requiredKey = ["consoleRunName", "authUrl", "userName", "projectName", "local"];
  currentUser: any;
  firstName: any;
  userName: any;
  url: any;
  authUrl: any;
  escape_keypress = 'true';
  sleepInterval = 1000;
  detailReport = 'true';
  local = 'true';
  consolidatedReport = 'true';
  consolidatedProjectReport = 'true';
  submitted: boolean;
  tokenForm: FormGroup;
  currentToken: any;
  today = new Date().toISOString().split('T')[0];
  inputFieldsData: any;

  @ViewChild('closeTokenForm', null) closeTokenForm: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private toasterService: ToastrService,
    private confirmationDialogService : ConfirmationDialogService,
    private userService: UserService,
    private toastrService: ToastrService,
    private formBuilder: UntypedFormBuilder
  ) {
    this.url = environment.baseUrl
   }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    console.log(this.currentUser)
    this.userName = this.currentUser.email;
    this.authUrl = this.url + '/'+'HuLoopRest' 
    this.route.paramMap.subscribe(
      (params: any) => {
        this.projectId = params.get('pid');
        this.initConsoleData();
      }
    )

    this.tokenForm = this.formBuilder.group(
      {
        date: ["", [Validators.required]],
      },
    );
    
  }

  initConsoleData() {
    this.consoleData = [];
    this.consoleTableData = [];
    this.inputFieldsList = [];
    this.projectService.getconsoleData(this.projectId).subscribe((response) => {
      this.consoleData = response['listConsole'];
      this.consoleData.forEach(element => {
        let tableContent = {};
        tableContent['uniqueId'] = element.uniqueId;
        tableContent['consoleRunName'] = element.consoleData[0].consoleRunName
        this.consoleTableData.push(tableContent);
      });
    })

    this.projectService.getConsoleRunData().subscribe((response) => {
      response['list'].forEach((element) => {
        let body = { "key": "", "value":""};

        var tokenName = "";
        if(this.currentUser["loginToken"]) {
          tokenName = "CLI_Access_Token";
        }
        
        body['key'] = element;
          body['key']=='authUrl'? body['value']=this.authUrl : 
          body['key']=='userName'? body['value']=this.userName : 
          body['key']=='escape_keypress' ? body['value']= this.escape_keypress: 
          body['key']=='local'? body['value']=this.local:
          body['key']=='consolidatedReport'? body['value']=this.consolidatedReport:
          body['key']=='consolidatedProjectReport'? body['value']=this.consolidatedProjectReport:
          body['key']=='accessToken'? body['value']=tokenName:
          ''
        this.inputFieldsList.push(body)
      })
    })
  }

  saveConsoleData() {

    let isFormInvalid = false;
    this.inputFieldsList.forEach(element => {

      this.requiredKey.forEach((data) => {
        if (element['key'] == data) {
          if (element['value'] == '') {
            isFormInvalid = true;
          }
        }
      })

    });

    if (isFormInvalid) {
      this.toasterService.warning("Required fields can not be blank");
      return;
    }
    else {
      let body = {};
      this.inputFieldsList.forEach((data) => {
        body[data.key] = data.value
      })
      body['projectId'] = this.projectId;

      if(body['accessToken']) {
        body['accessToken'] = this.currentUser["loginToken"];
      }

      this.projectService.addConsoleSetting(body).subscribe((response) => {
        this.toasterService.success("Console data saved")
        this.initConsoleData();

        let currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        currentUser.accessToken = this.currentUser["loginToken"];
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
      })
    }


  }

  openRow(selectedRow) {
    this.showForm = true;
    let selectedElement = this.consoleData.filter((data) => data.uniqueId == selectedRow.uniqueId);
    let data = selectedElement[0].consoleData[0];
    this.inputFieldsList.forEach(element => {
      if(element.key == "accessToken") {
        element.value = this.currentUser["tokenName"];
      } else {
        element.value = data[element.key];
      }
    });
  }

  deleteRow(selectedRow) {
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ?')
    .afterClosed().subscribe(res => {
      if (res) {
        let selectedElement = this.consoleData.filter((data) => data.uniqueId == selectedRow.uniqueId);
        this.projectService.deleteSetting(selectedElement[0]['id']).subscribe((response) => {
          this.toasterService.success("Console data deleted")
          this.initConsoleData();
          this.clearFields();
        })
      }
    });
  }

  clearFields() {
    this.inputFieldsList.forEach(element => {
      if(element['key'] != "accessToken")
        element['value'] = '';
    });
  }

  
  isFormValid()
  {
    let disableClear : boolean = true;
    this.inputFieldsList.forEach(element => {
      if(element.value != '')
      {
        disableClear = false
      }
    });
    return disableClear;
  }

  getExpiryDate(){
  this.submitted = true;
  if (this.tokenForm.invalid) {
    return;
  }
  
  const dateValue = this.tokenForm.value.date;
  const selectedDate = new Date(dateValue);
  
  // Check if selected date is today
  const today = new Date();
  const isToday = selectedDate.toDateString() === today.toDateString();
  
  let dateInMillis;
  
  if (isToday) {
    // If today is selected, set time to end of day (23:59:59.999)
    selectedDate.setHours(23, 59, 59, 999);
    dateInMillis = selectedDate.getTime();
    console.log('Today selected - expiry set to midnight:', new Date(dateInMillis));
  } else {
    // For future dates, keep the default time (start of day)
    dateInMillis = selectedDate.getTime();
    console.log('Future date selected:', new Date(dateInMillis));
  }
  
  console.log('Date in milliseconds:', dateInMillis);
  
  var tokenObj = {
    email: this.currentUser.email,
    tokenCreatedDate: new Date().getTime(),
    tokenName: "CLI_Access_Token"
  }
  
  this.userService.generateToken(dateInMillis, tokenObj).subscribe(
    (res: any) => {
      
      this.currentUser["loginToken"] = res;
      this.currentUser["tokenName"] = tokenObj["tokenName"];

      this.inputFieldsList.forEach((data) => {
        if(data.key == "accessToken") {
          data.value = tokenObj["tokenName"];
        }
      })

      //let currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      //currentUser.accessToken = this.currentUser["loginToken"];
      //localStorage.setItem('currentUser', JSON.stringify(currentUser));

      this.currentToken = res;
      this.inputFieldsData = this.inputFieldsList.map(item => ({...item}));
      this.updateAllConsoleData();
      this.closeTokenForm.nativeElement.click();
      this.toastrService.clear();
      this.toastrService.success('Access token generated successfully');
      this.loadUser();
    }
  );
}

loadUser()
  {
    this.userService.getUser().subscribe((res)=>{
      localStorage.setItem('currentUser', JSON.stringify(res));
      this.currentUser = res;
    })

  }

updateAllConsoleData() {
  this.consoleData.forEach(cData => {
    let data = cData.consoleData[0];
    let body = {};
    this.inputFieldsList.forEach(fieldData => {
      if(fieldData.key == "accessToken") {
        fieldData.value = this.currentUser["tokenName"];
      }
       else {
        fieldData.value = data[fieldData.key];
       }
      body[fieldData.key] = fieldData.value
    });

    body['projectId'] = this.projectId;

    // if(body['accessToken']) {
    body['accessToken'] = this.currentUser["loginToken"];
    // }

    this.projectService.addConsoleSetting(body).subscribe((response) => {
      let currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
      currentUser.accessToken = this.currentUser["loginToken"];
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    });

  });

  this.inputFieldsList = this.inputFieldsData;
  // this.initConsoleData();
}


}
